import { Star } from 'lucide-react';
import { t } from '@lingui/macro';
import { Workspace } from '../../models/Workspace';
import { useToast } from '../../hooks/use-toast';

const PremiumWSIcon: React.FC<{ ws: Workspace | undefined }> = ({ ws }) => {
  const { toast } = useToast();

  if (ws?.tier && ws.tier !== 'FREE') {
    return (
      <Star
        className="w-4 h-4 text-yellow-400 ml-1 cursor-pointer"
        onClick={show}
      />
    );
  } else {
    return <></>;
  }

  function show() {
    toast({
      title: ws?.name,
      description: t`${ws?.name} is a ${ws?.tier} workspace.`
    });
  }
}

export default PremiumWSIcon;
